import { defineMessages } from 'react-intl';

export default defineMessages({
    claimsDetailTitle: {
        id: 'claim.views.claim-infos.claim.views.claim-detail.Claims Details',
        defaultMessage: 'Claims Details'
    },
    vendorsInvolved: {
        id: 'claim.views.claim-infos.claim.views.claim-detail.Vendors involved',
        defaultMessage: 'Vendors involved'
    }
});
